export const ACTION_CARD_COLORS = {
  incident: {
    label: "Real incident",
    fill: "#E20019",
    text: "#791F1F",
  },
  prevention: {
    label: "Prevention",
    fill: "#639922",
    text: "#27500A",
  },
  nearMiss: {
    label: "Near miss",
    fill: "#EF9F27",
    text: "#633806",
  },
  training: {
    label: "Training",
    fill: "#5EA0E4",
    text: "#0C447C",
  },
  read: {
    label: "Read",
    fill: "#AFA9EC",
    text: "#3C3489",
  },
  doubt: {
    label: "Doubt about reporting",
    fill: "#B4B2A9",
    text: "#444441",
  },
};

const hexToRgb = (hex) => {
  const normalized = hex.replace("#", "");
  const value = parseInt(normalized, 16);

  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255,
  };
};

// Keep soft UI tints tied to the approved semantic palette.
export const getActionCardToneStyle = (tone) => {
  const { r, g, b } = hexToRgb(tone.fill);

  return {
    "--quiz-fill": tone.fill,
    "--quiz-text": tone.text,
    "--quiz-soft": `rgba(${r}, ${g}, ${b}, 0.12)`,
    "--quiz-ring": `rgba(${r}, ${g}, ${b}, 0.18)`,
  };
};

export const RISK_CHART_COLORS = {
  default: ACTION_CARD_COLORS.incident.fill,
  green: ACTION_CARD_COLORS.prevention.fill,
  yellow: ACTION_CARD_COLORS.nearMiss.fill,
  red: ACTION_CARD_COLORS.incident.fill,
  training: ACTION_CARD_COLORS.training.fill,
  reading: ACTION_CARD_COLORS.read.fill,
  nearMiss: ACTION_CARD_COLORS.nearMiss.fill,
  prevention: ACTION_CARD_COLORS.prevention.fill,
  doubt: ACTION_CARD_COLORS.doubt.fill,
};
